import React from 'react';
import './PricingSomething.css';

// SVG for the 5-star rating, encapsulated in its own component
const StarRating = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="103" height="20" viewBox="0 0 103 20" fill="none">
    <path d="M9.09722 3.7515C9.39154 2.81979 10.71 2.81979 11.0043 3.7515L11.9046 6.6014C12.036 7.01738 12.4219 7.30017 12.8581 7.30017H15.8301C16.792 7.30017 17.1992 8.52541 16.4287 9.10121L13.9763 10.9339C13.6357 11.1884 13.4933 11.6306 13.6214 12.0361L14.5466 14.965C14.8392 15.8913 13.7726 16.6487 12.9944 16.0672L10.6494 14.3148C10.2944 14.0495 9.80715 14.0495 9.45216 14.3148L7.10712 16.0672C6.32898 16.6487 5.26234 15.8913 5.55495 14.965L6.48015 12.0361C6.60825 11.6306 6.46587 11.1884 6.12522 10.9339L3.67285 9.10121C2.90234 8.52541 3.30958 7.30017 4.27147 7.30017H7.2434C7.67965 7.30017 8.06555 7.01738 8.19695 6.6014L9.09722 3.7515Z" fill="#FF9900"></path>
    <path d="M29.69 3.7515C29.9843 2.81979 31.3028 2.81979 31.5971 3.7515L32.4974 6.6014C32.6288 7.01738 33.0147 7.30017 33.4509 7.30017H36.4229C37.3847 7.30017 37.792 8.52541 37.0215 9.10121L34.5691 10.9339C34.2285 11.1884 34.0861 11.6306 34.2142 12.0361L35.1394 14.965C35.432 15.8913 34.3653 16.6487 33.5872 16.0672L31.2422 14.3148C30.8872 14.0495 30.3999 14.0495 30.0449 14.3148L27.6999 16.0672C26.9218 16.6487 25.8551 15.8913 26.1477 14.965L27.0729 12.0361C27.201 11.6306 27.0586 11.1884 26.718 10.9339L24.2656 9.10121C23.4951 8.52541 23.9024 7.30017 24.8642 7.30017H27.8362C28.2724 7.30017 28.6583 7.01738 28.7897 6.6014L29.69 3.7515Z" fill="#FF9900"></path>
    <path d="M50.5483 3.65996C50.8476 2.73865 52.1511 2.73865 52.4504 3.65996L53.4087 6.60919C53.5425 7.02121 53.9265 7.30017 54.3597 7.30017H57.4607C58.4295 7.30017 58.8322 8.53979 58.0485 9.10919L55.5398 10.9319C55.1893 11.1866 55.0426 11.6379 55.1765 12.0499L56.1347 14.9992C56.4341 15.9205 55.3796 16.6866 54.5959 16.1172L52.0871 14.2945C51.7366 14.0398 51.2621 14.0398 50.9116 14.2945L48.4028 16.1172C47.6191 16.6866 46.5646 15.9205 46.864 14.9992L47.8222 12.0499C47.9561 11.6379 47.8094 11.1866 47.459 10.9319L44.9502 9.10919C44.1665 8.53979 44.5692 7.30017 45.538 7.30017H48.639C49.0722 7.30017 49.4562 7.02121 49.59 6.60919L50.5483 3.65996Z" fill="#FF9900"></path>
    <path d="M71.4029 3.7515C71.6972 2.81979 73.0157 2.81979 73.31 3.7515L74.2103 6.6014C74.3417 7.01738 74.7276 7.30017 75.1638 7.30017H78.1357C79.0976 7.30017 79.5049 8.52541 78.7344 9.10121L76.282 10.9339C75.9413 11.1884 75.799 11.6306 75.9271 12.0361L76.8523 14.965C77.1449 15.8913 76.0782 16.6487 75.3001 16.0672L72.9551 14.3148C72.6001 14.0495 72.1128 14.0495 71.7578 14.3148L69.4128 16.0672C68.6346 16.6487 67.568 15.8913 67.8606 14.965L68.7858 12.0361C68.9139 11.6306 68.7715 11.1884 68.4309 10.9339L65.9785 9.10121C65.208 8.52541 65.6152 7.30017 66.5771 7.30017H69.5491C69.9853 7.30017 70.3712 7.01738 70.5026 6.6014L71.4029 3.7515Z" fill="#FF9900"></path>
    <path d="M91.9957 3.7515C92.29 2.81979 93.6084 2.81979 93.9028 3.7515L94.803 6.6014C94.9344 7.01738 95.3203 7.30017 95.7566 7.30017H98.7285C99.6904 7.30017 100.098 8.52541 99.3271 9.10121L96.8748 10.9339C96.5341 11.1884 96.3917 11.6306 96.5198 12.0361L97.445 14.965C97.7376 15.8913 96.671 16.6487 95.8929 16.0672L93.5478 14.3148C93.1928 14.0495 92.7056 14.0495 92.3506 14.3148L90.0056 16.0672C89.2274 16.6487 88.1608 15.8913 88.4534 14.965L89.3786 12.0361C89.5067 11.6306 89.3643 11.1884 89.0237 10.9339L86.5713 9.10121C85.8008 8.52541 86.208 7.30017 87.1699 7.30017H90.1418C90.5781 7.30017 90.964 7.01738 91.0954 6.6014L91.9957 3.7515Z" fill="#FF9900"></path>
  </svg>
);

// Reusable card component for testimonials
const TestimonialCard = ({ quote, author, company }) => (
  <div className="testimonial-card">
    <StarRating />
    <p className="testimonial-quote">“{quote}”</p>
    <p className="testimonial-author">
      <strong>{author}</strong> | {company}
    </p>
  </div>
);

// Main component
const PricingSomething = () => {
  // Data for testimonials and badges stored in arrays for easy mapping
  const testimonials = [
    {
      quote: "Sendbird provides all the tools to build a fully digital, modern chat experience. The product is very flexible and scalable... Fast go-to-market and a great team of engineers.",
      author: "Özgür G",
      company: "Virgin Mobile"
    },
    {
      quote: "Sendbird is convenient to use. They have a very responsive support team who addresses the questions and gets back with answers quickly. The experience continues to be positive.",
      author: "Yash W",
      company: "Ahold Delhaize"
    }
  ];

  const badges = [
    { src: "https://sendbird.imgix.net/cms/g2-spring-25-grid-leader-enterprise-1.png", alt: "G2 Spring 2025 Grid Leader Enterprise" },
    { src: "https://sendbird.imgix.net/cms/g2-spring-25-gird-leader-mid-market-2.png", alt: "G2 Spring 2025 Grid Leader Mid-Market" },
    { src: "https://sendbird.imgix.net/cms/g2-spring-25-grid-leader-3.png", alt: "G2 Spring 2025 Grid Leader" },
    { src: "https://sendbird.imgix.net/cms/g2-spring-25-users-love-4.png", alt: "G2 Spring 2025 Users Love Us" }
  ];

  return (
    <div className="pricing-something-wrapper">
      <div className="pricing-something-container">
        <div className="header-section">
          <div className="header-text">
            <h4>
              Why business and engineering leaders choose Sendbird's customer
              communications API platform
            </h4>
          </div>
          <div className="header-badges">
            {badges.map((badge, index) => (
              <img key={index} src={badge.src} alt={badge.alt} className="badge-image" />
            ))}
          </div>
        </div>
        <div className="testimonials-section">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              quote={testimonial.quote}
              author={testimonial.author}
              company={testimonial.company}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingSomething;